import {Pipe, PipeTransform} from '@angular/core';
import {LocalDto} from '../../Models/Local/local.interface';

@Pipe({
  name: 'localFamilies',
  standalone: false
})
export class LocalFamiliesPipe implements PipeTransform {

  transform(items: LocalDto[], family: number): LocalDto[] {

    if (!items || items.length === 0) {
      return [];
    }

    if (family) {
      items = items.filter((item) => item.id_familia === family);
    }

    return items;

  }
}
